var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.10018 19.5916H12.6026C14.455 19.5916 15.3767 18.6521 15.3767 16.7909V8.66625C15.3767 7.51175 15.2514 7.01085 14.5356 6.27707L9.59614 1.25745C8.91657 0.559175 8.36147 0.407227 7.35052 0.407227H3.10018C1.25695 0.407227 0.326172 1.35556 0.326172 3.21712V16.7909C0.326172 18.6608 1.25695 19.5916 3.10018 19.5916ZM3.17157 18.1512C2.24995 18.1512 1.76662 17.6587 1.76662 16.7642V3.24384C1.76662 2.35812 2.24995 1.84768 3.18073 1.84768H7.15352V7.04674C7.15352 8.17413 7.72619 8.72886 8.83564 8.72886H13.9362V16.7642C13.9362 17.6587 13.4617 18.1512 12.5313 18.1512H3.17157ZM8.99675 7.37736C8.6478 7.37736 8.50425 7.23458 8.50425 6.87647V2.12523L13.6583 7.37774L8.99675 7.37736Z",
    fill: "#949699"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document-icon.dd5734ce4b29dd4aea94d7ffc3fe9127.svg";
export { ForwardRef as ReactComponent };